export default __webpack_public_path__ + "static/media/une (5).ef2ba89c.png";